import React from 'react'
import Drawer from '@mui/material/Drawer';
import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import { getInvoice } from '../../../Controllers/BookingManagement';
import moment from 'moment';
import { _invoiceStatusDsiplay } from '../../../constants';
import { formatWithTZ } from "../../../utils"


const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN

const JobInvoice = ({ open, setOpen, applicationId }) => {
    const [state, setState] = React.useState({
        applicationId: null,
        _id: null,
        invoiceInfo: {},
        paymentStatus: "",
        createdAt: new Date()
    })

    React.useEffect(() => {
        async function getBookingInvoice() {
            const res = await getInvoice(applicationId)

            if (res.data.status === 200) {
                setState({ ...state, ...res.data.data })
            }
        }
        getBookingInvoice()
    }, [])

    return (
        <>
            <Drawer anchor={anchor} open={open.open} onClose={() => { setOpen({ open: false }) }}>
                <Container>
                    {
                        true ?
                            <>
                                <Header>
                                    <h4>Invoice #{state.displayedJobId}</h4>
                                    <CloseIcon className='pointer' onClick={() => { setOpen({ open: false }) }} />
                                </Header>
                                <Body className='scroll-bar-hidden'>
                                    <div className='on-date'>on {moment(state.createdAt).format("DD/MM/YYYY")}</div>
                                    <div className="logo">
                                        <img src="/assets/Logo.png" alt="" />
                                    </div>
                                    <Divider className='divider-gap' />
                                    <div className='user-detail'>
                                        <div className="active"><Avatar
                                            alt=""
                                            src=""
                                            sx={{ width: 24, height: 24 }}
                                        />{state.invoiceInfo?.payBy?.firstName} {state.invoiceInfo?.payBy?.lastName}</div>
                                        <div>billed to</div>
                                        <div className='active'><Avatar
                                            alt=""
                                            src=""
                                            sx={{ width: 24, height: 24 }}
                                        />{state.invoiceInfo?.payTo?.firstName} {state.invoiceInfo?.payTo?.lastName}</div>
                                    </div>
                                    <Divider className='divider-gap' />
                                    <TimeDetails>
                                      {state.invoiceInfo?.availability?.map((e, idx) => {
                                        const firstSlot = e.availabilityTime?.[0];
                                    
                                        return (
                                          <div key={idx}>
                                            <div className="active">
                                              {firstSlot
                                                ? `${formatWithTZ(firstSlot.startUTCTime, "ddd, DD/MM/YYYY")} - ${formatWithTZ(firstSlot.endUTCTime, "ddd, DD/MM/YYYY")}`
                                                : "-"}
                                            </div>
                                            
                                            {e.availabilityTime?.map((avail, i) => (
                                              <div key={i}>
                                                From {formatWithTZ(avail.startUTCTime, "HH:mm")} to{" "}
                                                {formatWithTZ(avail.endUTCTime, "HH:mm")}
                                              </div>
                                            ))}
                                          </div>
                                        );
                                      })}
                                    </TimeDetails>
                                    <Divider className='divider-gap' />
                                    <div className="amount-details">
                                        {
                                            state?.invoiceInfo.bookingFor === "BabySitter" ?
                                                <React.Fragment>
                                                    <div style={{ display: "flex", margin: "10px 0" }}>
                                                        <div>Total hours- day</div>
                                                        <div>{state.invoiceInfo?.billDetail?.providerView?.totalHours - state.invoiceInfo?.billDetail?.totalOvernightHour} hrs</div>
                                                    </div>
                                                    <div style={{ display: "flex", margin: "10px 0" }}>
                                                        <div>Total hours- overnight</div>
                                                        <div>{state.invoiceInfo?.billDetail?.totalOvernightHour || 0} hrs</div>
                                                    </div>
                                                    <div style={{ display: "flex", margin: "10px 0" }}>
                                                        <div>Day rate per hours</div>
                                                        <div>{state.invoiceInfo?.billDetail?.hourlyRate} hrs</div>
                                                    </div>
                                                    <div style={{ display: "flex", margin: "10px 0" }}>
                                                        <div>Overnight rate per hours</div>
                                                        <div>{state.invoiceInfo?.billDetail?.overnightRate} hrs</div>
                                                    </div></React.Fragment>
                                                :
                                                <React.Fragment>
                                                    <div>
                                                        <div>Total hours</div>
                                                        <div>{state.invoiceInfo?.billDetail?.providerView?.totalHours} hrs</div>
                                                    </div>

                                                    <div>
                                                        <div>Rate per hours</div>
                                                        <div>{state.invoiceInfo?.billDetail?.hourlyRate} hrs</div>
                                                    </div>
                                                </React.Fragment>
                                        }
                                        <Divider className='m10' />
                                        <div>
                                            <div>Sub total</div>
                                            <div>{state.invoiceInfo?.billDetail?.providerView?.payableAmount} €</div>
                                        </div>
                                        <Divider />
                                        <div><div>Extra expenses</div><div> € {state.invoiceInfo?.billDetail?.meta?.extraCharges}</div></div>
                                        <Divider />

                                        <div><div>Nona fee</div><div> € {state.invoiceInfo?.billDetail?.providerView?.totalNonaFee}</div></div>
                                        <div><div>Promo code</div><div>{state.invoiceInfo?.billDetail?.seekerView?.code || "N/A"}</div></div>
                                        <div><div>Discount price</div><div> € {state.invoiceInfo?.billDetail?.seekerView?.discountPrice}</div></div>

                                        <div><div>Tip</div><div> € {state.invoiceInfo?.billDetail?.meta?.tip}</div></div>
                                    </div>
                                    <Divider className='divider-gap' />
                                    <div className="amount-details">
                                        <div><div>Total</div><div>€ {state.invoiceInfo?.billDetail?.seekerView?.totalAmount}</div></div>
                                    </div>
                                    <Divider className='divider-gap' />
                                    
                                  
                            
                                    <div className="amount-details">
                                        <div><div>*Transaction charges</div><div>€ {state?.paypalFeeBreakDown?.paypal_fee.value ? "-" : ""}{state?.stripeFeeBreakDown?.application_fee_amount || state?.paypalFeeBreakDown?.paypal_fee.value || 0}</div></div>
                                    </div>
                                   
                                    <Divider className='divider-gap' />
                                    
                                  
                            
                                    <div className='active on-date' style={{ fontFamily: "semi-bold" }}>
                                      {_invoiceStatusDsiplay[state?.paymentStatus] || "Unknown Status"}
                                   </div>                                
                                </Body>
                            </>
                            :
                            <>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <CircularProgress />
                                </div>
                            </>
                    }
                </Container>
            </Drawer>
        </>
    )
}

const Container = styled("div")`
    height: 100vh;
    width: 30vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
    font-family: 'regular';
    font-size: 85%;
    .active{
        color: var(--nona-theme-color);
    }
    .divider-gap{
        margin: 1rem 0;
    }
    .m10:{
        margin:10px 0;
    }
    .logo {
        width: 30%;
        margin: auto;
    }
    .logo img {
        width: 100%;
        object-fit: contain;
    }
    .on-date{
        font-family: 'semi-bold';
        font-size: 80%;
        letter-spacing: 0.6px;
    }
    .user-detail{
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;
        div{
            display: flex;
            align-items: center;
            column-gap: 0.5rem;
        }
    }
    .amount-details{
        display: grid;
        row-gap: 0.5rem;
        &>div{
            display: flex;
            justify-content: space-between;
        }
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-family: 'semi-bold';
        font-size: 100%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

const TimeDetails = styled("div")`
    margin-top: 1rem;
   div{
       margin-bottom: 0.2rem;
       display: flex;
       justify-content: space-between;
   } 
`;

export default JobInvoice